import { CardHeader, CardContent } from '@mui/material';

import StatsPeriodSelector, {
  getDefaultPeriodArgs,
} from 'components/StatsPeriodSelector';
import { DashboardContent } from 'pages/Dashboard';
import DailyStatsChart from 'pages/Play/DailyStatsChart';
import React, { useCallback, useState } from 'react';
import Simplebar from 'simplebar-react';
import PlaysDashboardTitle from './PlaysDashboardTitle';
import PodcastMetricsByDayTable from './PodcastMetricsByDateTable/PodcastMetricsByDateTable';
import PodcastEpisodesTable from './PodcastMetricsByEpisodeTable';
import * as S from './styles';
import { EpisodeDetails, PodcastPlaysView } from './types';

type PlaysDashboardProps = {};

const PlaysDashboard: React.FC<PlaysDashboardProps> = () => {
  const [view, setView] = useState<PodcastPlaysView>('daily');
  const [periodArgs, setPeriodArgs] = useState(getDefaultPeriodArgs());
  const [episodeDetails, setEpisodeDetails] = useState<EpisodeDetails>();

  const handleToggleView = useCallback(() => {
    setView(view === 'daily' ? 'episode' : 'daily');
  }, [view]);
  return (
    <DashboardContent maxWidth="xl">
      <S.Card>
        <CardHeader
          action={<StatsPeriodSelector onSelectPeriod={setPeriodArgs} />}
          title={
            <PlaysDashboardTitle
              episodeDetails={episodeDetails}
              onGoBack={() => setEpisodeDetails(undefined)}
            />
          }
        />
        <CardContent component={Simplebar}>
          <DailyStatsChart
            periodArgs={periodArgs}
            episodeId={episodeDetails?.remoteEpisodeId}
          />
        </CardContent>
      </S.Card>
      {!episodeDetails?.remoteEpisodeId && (
        <S.Toggle view={view} onChange={handleToggleView} />
      )}
      {view === 'episode' && !episodeDetails?.remoteEpisodeId ? (
        <PodcastEpisodesTable onRowClick={setEpisodeDetails} />
      ) : (
        <PodcastMetricsByDayTable
          startMillis={periodArgs.startMillis}
          endMillis={periodArgs.endMillis}
          remoteEpisodeId={episodeDetails?.remoteEpisodeId}
        />
      )}
    </DashboardContent>
  );
};
export default PlaysDashboard;
